import { injectIntl } from "react-intl";
import { useEffect, useState } from "react";
import Header from "./Header";
import apiService from "src/services/api.service";
import { PageEnum } from "src/helpers/Enums";
import Empty from "src/components/Empty";
import SearchLine from "src/components/SearchLine";
import CreativesTable from "./CreativesTable";
import DeleteCreative from "./DeleteCreative";
import EditCreative from "./EditCreative";

const EmailCreative = () => {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [chosenList, setChosenList] = useState();
  const [deleteIds, setDeleteIds] = useState(null);
  const [deleteNonce, setDeleteNonce] = useState(0);
  const [isEditCreativeOpen, setIsEditCreativeOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortField, setSortField] = useState("last_used_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [everflowMatched, setEverflowMatched] = useState(null);

  const handleEverflowMatchedChange = (value) => {
    setEverflowMatched(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    apiService
      .getAllCreativesV2({
        type: "Email",
        page: currentPage,
        limit,
        sortField,
        sortOrder,
        search,
        everflowMatched,
      })
      .then((response) => {
        setList(response.data?.data || []);
        setCurrentPage(response.data?.pagination?.page || 1);
        setLimit(response.data?.pagination?.limit || limit);
        setTotalPages(response.data?.pagination?.totalPages ?? 1);
        setTotalCount(response.data?.pagination?.total ?? 0);
      });
  }, [currentPage, limit, sortField, sortOrder, search, everflowMatched]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const handleOpenEditCreative = (list) => {
    setChosenList(list);
    setIsEditCreativeOpen(true);
  };

  const refreshCreativesList = () => {
    apiService
      .getAllCreativesV2({
        type: "Email",
        page: currentPage,
        limit,
        sortField,
        sortOrder,
        search,
        everflowMatched,
      })
      .then((response) => {
        setList(response.data?.data || []);
        setCurrentPage(response.data?.pagination?.page || 1);
        setLimit(response.data?.pagination?.limit || limit);
        setTotalPages(response.data?.pagination?.totalPages ?? 1);
        setTotalCount(response.data?.pagination?.total ?? 0);
      });
  };

  const handleEditUpdateSuccess = () => {
    setIsEditCreativeOpen(false);
    setDeleteIds(null);
    refreshCreativesList();
  };

  const closeModal = () => {
    setIsEditCreativeOpen(false);
    setDeleteIds(null);
  };

  const handleOpenDeleteCreative = (list) => {
    setChosenList(list);
    setDeleteIds([list._id]);
  };

  const handleOpenDeleteSelected = (ids) => {
    if (!ids?.length) {
      return;
    }
    setDeleteIds(ids);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSortChange = (field, isAscending) => {
    setSortField(field);
    setSortOrder(isAscending ? "asc" : "desc");
    setCurrentPage(1);
  };

  return (
    <div className={"Page"}>
      <Header
        setSearch={setSearch}
        search={search}
        title="Email"
        subtitle={totalCount}
        everflowMatched={everflowMatched}
        onEverflowMatchedChange={handleEverflowMatchedChange}
      ></Header>
      {search && (
        <SearchLine setSearch={setSearch} search={search}></SearchLine>
      )}
      {list?.length > 0 ? (
        <div className={"ListsPage"}>
          <CreativesTable
            list={list}
            handleOpenEditCreative={handleOpenEditCreative}
            handleOpenDeleteCreative={handleOpenDeleteCreative}
            handleOpenDeleteSelected={handleOpenDeleteSelected}
            deleteNonce={deleteNonce}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            pageSize={limit}
            onPageChange={handlePageChange}
            sortField={sortField}
            sortOrder={sortOrder}
            onSortChange={handleSortChange}
          ></CreativesTable>
        </div>
      ) : (
        <Empty
          title={"No creatives Found"}
          description={
            "No creatives match your search. Review your keywords or filters to refine your results."
          }
          menu={PageEnum.SEARCH}
          noButton={true}
        ></Empty>
      )}
      {deleteIds?.length > 0 && (
        <DeleteCreative
          ids={deleteIds}
          close={closeModal}
          onDeleted={() => {
            setDeleteNonce((n) => n + 1);
            refreshCreativesList();
          }}
        />
      )}
      {isEditCreativeOpen && (
        <EditCreative
          closeModal={closeModal}
          onUpdateSuccess={handleEditUpdateSuccess}
          creative={chosenList}
          type="Email"
        />
      )}
    </div>
  );
};

export default injectIntl(EmailCreative);
